import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import type { Content } from '../content/types';
type Props = {
  content: Content['solution'];
};
export function Solution({
  content
}: Props) {
  return <section className="bg-brand-dark py-16 sm:py-24 lg:py-32 px-5 sm:px-6 md:px-12 lg:px-24" data-id="element-86">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-24 items-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="order-2 lg:order-1 relative w-full aspect-[3/4] max-w-md mx-auto lg:max-w-none" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/acooiqDzAZobJoYNZD1XmT/PHOTO_BUREAU_FOND_MODERNE.png" alt="Rebeca Oliveira" className="w-full h-full object-cover rounded-[8px] shadow-2xl" data-id="element-89" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="order-1 lg:order-2 flex flex-col" data-id="element-90">
          <h2 className="text-[26px] sm:text-[32px] lg:text-[36px] font-bold text-brand-cream mb-6 sm:mb-8 leading-tight whitespace-pre-line" data-id="element-91">
            {content.title}
          </h2>

          <div className="space-y-5 sm:space-y-6 text-[15px] sm:text-[17px] text-brand-cream leading-[1.8] sm:leading-[1.9] mb-8 sm:mb-10" data-id="element-92">
            {content.paragraphs.map((p, i) => {
            if (typeof p === 'string') {
              return <p key={i} className="whitespace-pre-line" data-id="element-93">
                    {p}
                  </p>;
            }
            return <p key={i} className="whitespace-pre-line" data-id="element-94">
                  {p.quote ? <>
                      {p.text.split('\n').map((line, j) => <Fragment key={j} data-id="element-95">
                          {j > 0 && <br data-id="element-96" />}
                          {line.startsWith('"') && line.endsWith('"') ? <span className="italic" data-id="element-97">{line}</span> : line}
                        </Fragment>)}
                    </> : p.text}
                </p>;
          })}
          </div>

          <div className="w-[60px] h-[1px] bg-brand-gold/40 mx-auto lg:mx-0 my-6" data-id="element-98"></div>

          <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-8" data-id="element-99">
            {content.stats.map((stat, i) => <div key={i} className="bg-brand-darker rounded-[8px] p-3 sm:p-5 text-center flex flex-col justify-center" data-id="element-100">
                <span className="text-[22px] sm:text-[28px] lg:text-[32px] font-bold text-brand-gold mb-1 leading-none font-serif" data-id="element-101">
                  {stat.value}
                </span>
                <span className="text-[11px] sm:text-[13px] text-brand-cream/75 leading-tight whitespace-pre-line" data-id="element-102">
                  {stat.label}
                </span>
              </div>)}
          </div>

          <p className="text-[14px] text-brand-gold text-center lg:text-left" data-id="element-103">
            {content.langLine}
          </p>
        </motion.div>
      </div>
    </section>;
}